import { render, staticRenderFns } from "./GiftTextDescription.vue?vue&type=template&id=6fee6ae1&scoped=true&"
var script = {}
import style0 from "./GiftTextDescription.vue?vue&type=style&index=0&id=6fee6ae1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee6ae1",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BIconCheckSquare, BContainer} from 'bootstrap-vue'
    installComponents(component, {BIconCheckSquare, BContainer})
    

export default component.exports